
export class ReimbursementsDocs{
  constructor(
    public id?: number,
    public fileName?: string,
    public fileLocation?: string,
    public fileSize?: any,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/reimbursementsDocs.model.ts